export interface User {
  id: string;
  token: string;
  tokenExpiresAt: number;
}

export const userKey = "user";
